export default "__VITE_ASSET__U5YKh72R__"